import React, { Suspense } from 'react';

import ReactDOM from 'react-dom/client';

import './assets/styles/main.less';
import App from './App';
import PageSpinner from "./components/PageSpinner/PageSpinner";
import store from './store/app';
import { Provider } from 'react-redux'
import { HelmetProvider } from 'react-helmet-async';
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';

import "./views/webPages/style/homePage.less";
import "./assets/styles/CustomStyles/cutomStyles.css";
import "./assets/styles/custom/custom.css";
import "./assets/styles/custom/responsive.css";

import { createRoot } from 'react-dom/client'

createRoot(document.getElementById('root')!).render(
    <HelmetProvider>
        <Suspense fallback={<PageSpinner />}>
            <Provider store={store}>
                <StyleProvider hashPriority="high">
                    <ConfigProvider theme={{
                        token: {
                            fontFamily: "'Outfit', sans-serif",
                        }, hashed: false
                    }}>
                        <App />
                    </ConfigProvider>
                </StyleProvider>
            </Provider>
        </Suspense>
    </HelmetProvider>,
)
